module.exports = __webpack_public_path__ + "img/ee.bb83faa.svg";